/* eslint-disable no-param-reassign */

export default {
  install(Vue, options = {}) {
    const root = new Vue({ data() { return { isScriptLoaded: false } } })

    window.onSIApiReady = () => {
      root.isScriptLoaded = true
      root.$emit('loaded')
    }

    root.getChatStatus = () => window.SI_API.getChatStatus()
    root.addParams = params => window.SI_API.addParams(params)
    root.setChatInfo = (name, email, phone, group, question) => window.SI_API.setChatInfo(name, email, phone, group, question)

    root.showTab = settings => window.SI_API.showTab(settings)
    root.showPopup = settings => window.SI_API.showPopup(settings)
    root.showInvite = msg => window.SI_API.showInvite(msg)

    root.hideTab = settings => window.SI_API.hideTab(settings)
    root.hidePopup = settings => window.SI_API.hidePopup(settings)

    root.onChatOpened = callback => { window.SI_API.onChatOpened = callback }
    root.onChatClosed = callback => { window.SI_API.onChatClosed = callback }
    root.onChatEnded = callback => { window.SI_API.onChatEnded = callback }

    Vue.prototype.$SI = root
  },
}
